/* Esthy · carrito lateral propio.
   Se abre al agregar un producto o al tocar el ícono del carrito. Orden pensado para llevar al pago:
   barra de envío gratis arriba, productos con cantidad editable, máximo 2 sugeridos, subtotal con
   código de descuento aplicado (si hay), formas de pago y un solo botón dominante "Ir a pagar".
   Celular: hoja desde abajo. Compu: panel a la derecha. */
(function () {
  if (window.__esthyMiniCart) return;
  window.__esthyMiniCart = true;

  var GOAL = 100000; /* envío gratis desde $1,000 (centavos) */
  var BLUE = '#2c398d';
  var css = '' +
    '.emc-ov{position:fixed;inset:0;z-index:2147482999;background:rgba(10,20,50,.38);opacity:0;pointer-events:none;transition:opacity .2s ease}' +
    '.emc-ov.is-open{opacity:1;pointer-events:auto}' +
    '.emc-sheet{position:fixed;left:0;right:0;bottom:0;z-index:2147483000;background:#fff;color:#141414;display:flex;flex-direction:column;' +
    'border-radius:16px 16px 0 0;box-shadow:0 -10px 30px rgba(10,26,82,.18);max-height:90vh;transform:translateY(105%);transition:transform .25s ease;font-family:inherit}' +
    '.emc-sheet.is-open{transform:translateY(0)}' +
    '@media (min-width:900px){.emc-sheet{left:auto;top:0;width:420px;max-height:none;border-radius:0;transform:translateX(105%)}.emc-sheet.is-open{transform:translateX(0)}}' +
    '.emc-head{display:flex;align-items:center;justify-content:space-between;padding:10px 8px 6px 16px}' +
    '.emc-h{margin:0;font-size:17px;font-weight:700}' +
    '.emc-x{appearance:none;border:0;background:transparent;width:44px;height:44px;font-size:26px;line-height:1;color:#5b6070;cursor:pointer}' +
    '.emc-ok{margin:0 16px 4px;font-size:13.5px;font-weight:600;color:#1d6b3a}' +
    '.emc-ok[hidden]{display:none}' +
    '.emc-ship{padding:0 16px 12px;border-bottom:1px solid #eef0f6}' +
    '.emc-ship p{margin:0;font-size:13.5px;color:#1d2340}' +
    '.emc-bar{height:6px;margin-top:8px;border-radius:6px;background:#e6e8f3;overflow:hidden}' +
    '.emc-bar i{display:block;height:100%;background:' + BLUE + ';border-radius:6px;transition:width .3s ease}' +
    '.emc-body{flex:1;overflow-y:auto;padding:4px 16px 8px;-webkit-overflow-scrolling:touch}' +
    '.emc-item{display:flex;gap:10px;padding:12px 0;border-bottom:1px solid #f1f2f7}' +
    '.emc-item img{width:64px;height:64px;object-fit:contain;border-radius:8px;background:#f5f6fb;flex-shrink:0}' +
    '.emc-it{flex:1;min-width:0}' +
    '.emc-it a{display:block;font-size:13.5px;line-height:1.3;color:#141414;text-decoration:none;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}' +
    '.emc-var{display:block;margin-top:2px;font-size:12px;color:#6b6b6b}' +
    '.emc-row{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-top:8px}' +
    '.emc-q{display:inline-flex;align-items:center;border:1px solid #d9dceb;border-radius:10px;overflow:hidden}' +
    '.emc-q button{appearance:none;border:0;background:#fff;width:36px;height:36px;font-size:18px;color:#1d2340;cursor:pointer}' +
    '.emc-q span{min-width:28px;text-align:center;font-size:14px}' +
    '.emc-pr{font-size:14px;font-weight:700;white-space:nowrap}' +
    '.emc-pr s{display:block;font-weight:400;font-size:12px;color:#8a8a8a}' +
    '.emc-rm{appearance:none;border:0;background:transparent;padding:0;margin-top:6px;font:inherit;font-size:12px;color:#6b6b6b;text-decoration:underline;cursor:pointer}' +
    '.emc-empty{padding:28px 0;text-align:center;font-size:15px;color:#4a4f63}' +
    '.emc-up{padding:12px 0 4px}' +
    '.emc-up[hidden]{display:none}' +
    '.emc-up-t{margin:0 0 8px;font-size:13.5px;font-weight:700}' +
    '.emc-up-list{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:8px}' +
    '.emc-p{display:flex;gap:8px;align-items:center;border:1px solid #e6e8f3;border-radius:12px;padding:8px;min-width:0}' +
    '.emc-p img{width:44px;height:44px;object-fit:contain;flex-shrink:0;border-radius:6px;background:#f5f6fb}' +
    '.emc-p-i{flex:1;min-width:0}' +
    '.emc-p-n{font-size:12px;line-height:1.3;color:#3a3a3a;text-decoration:none;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}' +
    '.emc-p-pr{display:block;margin-top:2px;font-size:12.5px;font-weight:700}' +
    '.emc-add{appearance:none;border:1px solid ' + BLUE + ';background:#fff;color:' + BLUE + ';border-radius:10px;min-height:36px;padding:0 10px;font:inherit;font-size:12.5px;font-weight:600;cursor:pointer;flex-shrink:0}' +
    '.emc-add[disabled]{opacity:.6;cursor:default}' +
    '.emc-foot{padding:12px 16px calc(12px + env(safe-area-inset-bottom));border-top:1px solid #eef0f6;background:#fff}' +
    '.emc-sub{display:flex;justify-content:space-between;align-items:baseline;margin:0;font-size:15px}' +
    '.emc-sub b{font-size:18px}' +
    '.emc-disc{margin:8px 0 0;padding:8px 10px;border-radius:8px;background:#eef7f0;color:#1d6b3a;font-size:13px;font-weight:600;line-height:1.35}' +
    '.emc-disc.is-wait{background:#f4f5fa;color:#4a4f63;font-weight:500}' +
    '.emc-disc[hidden]{display:none}' +
    '.emc-note{margin:6px 0 0;font-size:12px;color:#6b6b6b}' +
    '.emc-go{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;min-height:54px;margin-top:10px;border-radius:14px;background:' + BLUE + ';color:#fff;font-size:16px;font-weight:700;text-decoration:none}' +
    '.emc-go svg{width:18px;height:18px;fill:none;stroke:#fff;stroke-width:2}' +
    '.emc-pay{display:flex;flex-wrap:wrap;justify-content:center;gap:6px;margin-top:10px}' +
    '.emc-pay svg{width:36px;height:22px}' +
    '.emc-trust{margin:8px 0 0;font-size:12px;color:#5b6070;text-align:center}' +
    '.emc-more{display:block;margin:8px auto 0;text-align:center;font-size:13px;color:#4a4f63;text-decoration:underline;background:none;border:0;font-family:inherit;cursor:pointer}' +
    '.emc-x:focus-visible,.emc-go:focus-visible,.emc-add:focus-visible,.emc-q button:focus-visible,.emc-rm:focus-visible,.emc-more:focus-visible{outline:2px solid ' + BLUE + ';outline-offset:2px}' +
    '.emc-busy{opacity:.55;pointer-events:none}' +
    'body.emc-open{overflow:hidden}' +
    'body.emc-open .rb-whatsapp-widget,body.emc-open [class*="kl-teaser"]{display:none!important}' +
    '@media (max-width:900px){body:has([id^="EpqSticky-"].is-visible) .rb-whatsapp-widget{transform:translateY(-78px)}}' +
    '@media (max-width:380px){.emc-up-list{grid-template-columns:minmax(0,1fr)}}' +
    '@media (prefers-reduced-motion:reduce){.emc-sheet,.emc-ov,.emc-bar i{transition:none}}';

  var sheet, ov, cart = null, lastUpFor = null, lastFocus = null;

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function getJSON(url, opts) { return fetch(url, opts || { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r; return r.json(); }); }
  function cookieCode() { var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/); return m ? decodeURIComponent(m[1]) : ''; }

  function build() {
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);
    ov = document.createElement('div');
    ov.className = 'emc-ov';
    ov.addEventListener('click', close);
    sheet = document.createElement('aside');
    sheet.className = 'emc-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Tu carrito');
    sheet.setAttribute('aria-hidden', 'true');
    var pay = document.getElementById('emc-pay-icons');
    sheet.innerHTML =
      '<div class="emc-head"><p class="emc-h">Tu carrito <span class="emc-n"></span></p><button type="button" class="emc-x" aria-label="Cerrar carrito">×</button></div>' +
      '<p class="emc-ok" hidden></p>' +
      '<div class="emc-ship"><p></p><div class="emc-bar" aria-hidden="true"><i style="width:0"></i></div></div>' +
      '<div class="emc-body"><div class="emc-items"></div><div class="emc-up" hidden><p class="emc-up-t"></p><div class="emc-up-list"></div></div></div>' +
      '<div class="emc-foot"><p class="emc-sub"><span>Subtotal</span><b></b></p><p class="emc-disc" role="status" hidden></p><p class="emc-note">Envío calculado al pagar. Gratis desde $1,000.</p>' +
      '<a class="emc-go" href="/checkout"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 018 0v3"/></svg><span>Ir a pagar</span></a>' +
      '<div class="emc-pay" aria-label="Formas de pago">' + (pay ? pay.innerHTML : '') + '</div>' +
      '<p class="emc-trust">Pago seguro · Originales, distribuidor oficial desde 1988 · Quincenas con Kueski</p>' +
      '<button type="button" class="emc-more">Seguir comprando</button></div>';
    document.body.appendChild(ov);
    document.body.appendChild(sheet);
    sheet.querySelector('.emc-x').addEventListener('click', close);
    sheet.querySelector('.emc-more').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) close(); });

    sheet.querySelector('.emc-items').addEventListener('click', function (e) {
      var b = e.target.closest('[data-k]'); if (!b) return;
      var key = b.getAttribute('data-k'), q = Number(b.getAttribute('data-q'));
      var row = b.closest('.emc-item'); if (row) row.classList.add('emc-busy');
      getJSON('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
        .then(function (c) { render(c, null); syncCount(c); })
        .catch(function () { if (row) row.classList.remove('emc-busy'); });
    });
    sheet.querySelector('.emc-up-list').addEventListener('click', function (e) {
      var b = e.target.closest('.emc-add'); if (!b) return;
      b.disabled = true; b.textContent = 'Agregando…';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-v')), quantity: 1 }] }) })
        .catch(function () { b.disabled = false; b.textContent = 'Agregar'; });
    });
  }

  function open(msg) {
    if (!sheet) build();
    var ok = sheet.querySelector('.emc-ok');
    if (msg) { ok.textContent = '✓ ' + msg; ok.hidden = false; } else { ok.hidden = true; }
    lastFocus = document.activeElement;
    document.body.classList.add('emc-open');
    sheet.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { ov.classList.add('is-open'); sheet.classList.add('is-open'); sheet.querySelector('.emc-x').focus({ preventScroll: true }); });
  }

  function close() {
    if (!sheet) return;
    sheet.classList.remove('is-open'); ov.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('emc-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* código de descuento: "GAMA30 aplicado · Ahorras $X" cuando ya descuenta; si el código está guardado
     pero ningún producto del carrito participa, se avisa para que no parezca que falló */
  function discount(c) {
    var d = sheet.querySelector('.emc-disc');
    var names = {};
    (c.items || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) {
        var t = a.discount_application && (a.discount_application.title || a.discount_application.code);
        if (t) names[t] = 1;
      });
    });
    (c.cart_level_discount_applications || []).forEach(function (a) { if (a.title) names[a.title] = 1; });
    var list = Object.keys(names), saved = c.total_discount || 0;
    var pending = (c.discount_codes || []).map(function (x) { return x.code; });
    if (!pending.length && cookieCode()) pending = [cookieCode()];
    d.classList.remove('is-wait');
    if (c.item_count && list.length && saved > 0) {
      d.textContent = '✓ Código ' + list.join(', ') + ' aplicado · Ahorras ' + money(saved);
      d.hidden = false;
    } else if (c.item_count && pending.length) {
      d.textContent = 'Código ' + pending.join(', ') + ' guardado: se aplica a los productos participantes.';
      d.classList.add('is-wait');
      d.hidden = false;
    } else {
      d.hidden = true;
    }
  }

  function render(c, addedTitle) {
    if (!sheet) build();
    cart = c;
    sheet.querySelector('.emc-n').textContent = c.item_count ? '(' + c.item_count + ')' : '';
    var total = c.total_price || 0, falta = GOAL - total;
    sheet.querySelector('.emc-ship p').innerHTML = !c.item_count ? 'Envío <b>gratis</b> en compras desde $1,000'
      : falta > 0 ? 'Te faltan <b>' + money(falta) + '</b> para tener <b>envío gratis</b>'
      : '<b>¡Ya tienes envío gratis!</b>';
    sheet.querySelector('.emc-bar i').style.width = Math.min(100, Math.round(total * 100 / GOAL)) + '%';
    var items = sheet.querySelector('.emc-items');
    if (!c.item_count) {
      items.innerHTML = '<p class="emc-empty">Tu carrito está vacío.</p>';
    } else {
      items.innerHTML = c.items.map(function (i) {
        var varTxt = i.variant_title && i.variant_title !== 'Default Title' ? '<span class="emc-var">' + esc(i.variant_title) + '</span>' : '';
        var plan = i.selling_plan_allocation ? '<span class="emc-var">' + esc(i.selling_plan_allocation.selling_plan.name) + '</span>' : '';
        var was = i.original_line_price > i.final_line_price ? '<s>' + money(i.original_line_price) + '</s>' : '';
        return '<div class="emc-item">' + (i.image ? '<img src="' + sized(i.image, 140) + '" alt="" loading="lazy">' : '') +
          '<div class="emc-it"><a href="' + i.url + '">' + esc(i.product_title) + '</a>' + varTxt + plan +
          '<div class="emc-row"><span class="emc-q"><button type="button" aria-label="Quitar uno" data-k="' + i.key + '" data-q="' + (i.quantity - 1) + '">−</button>' +
          '<span aria-label="Cantidad">' + i.quantity + '</span><button type="button" aria-label="Agregar uno" data-k="' + i.key + '" data-q="' + (i.quantity + 1) + '">+</button></span>' +
          '<span class="emc-pr">' + was + money(i.final_line_price) + '</span></div>' +
          '<button type="button" class="emc-rm" data-k="' + i.key + '" data-q="0">Eliminar</button></div></div>';
      }).join('');
    }
    sheet.querySelector('.emc-sub b').textContent = money(total);
    discount(c);
    sheet.querySelector('.emc-go').style.display = c.item_count ? '' : 'none';
    upsell(c, falta);
    if (addedTitle !== undefined && addedTitle !== null) open(addedTitle);
  }

  function upsell(c, falta) {
    var box = sheet.querySelector('.emc-up');
    var last = c.items && c.items[0];
    if (!last) { box.hidden = true; lastUpFor = null; return; }
    var inCart = {};
    c.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var key = last.product_id + ':' + c.item_count + ':' + (falta > 0);
    if (lastUpFor === key) return;
    lastUpFor = key;
    function get(intent) {
      return getJSON('/recommendations/products.json?product_id=' + last.product_id + '&limit=8' + (intent ? '&intent=' + intent : ''))
        .then(function (d) { return (d.products || []).filter(function (p) { return p.available && !inCart[p.id] && p.variants && p.variants.length; }); })
        .catch(function () { return []; });
    }
    get('complementary').then(function (list) { return list.length >= 2 ? list : get('').then(function (l2) { return list.concat(l2); }); })
      .then(function (list) {
        var seen = {}, uniq = [];
        list.forEach(function (p) { if (!seen[p.id]) { seen[p.id] = 1; uniq.push(p); } });
        if (falta > 0) {
          var reach = uniq.filter(function (p) { return p.price >= falta; }).sort(function (a, b) { return a.price - b.price; });
          var rest = uniq.filter(function (p) { return p.price < falta; }).sort(function (a, b) { return b.price - a.price; });
          uniq = reach.concat(rest);
        }
        var pick = uniq.slice(0, 2);
        if (!pick.length) { box.hidden = true; return; }
        box.querySelector('.emc-up-t').textContent = falta > 0 ? 'Agrega uno y llega al envío gratis' : 'Completa tu rutina';
        box.querySelector('.emc-up-list').innerHTML = pick.map(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          var img = p.featured_image || (p.images && p.images[0]) || '';
          return '<div class="emc-p">' + (img ? '<img src="' + sized(img, 100) + '" alt="" loading="lazy">' : '') +
            '<span class="emc-p-i"><a class="emc-p-n" href="/products/' + p.handle + '">' + esc(p.title) + '</a><span class="emc-p-pr">' + money(p.price) + '</span></span>' +
            '<button type="button" class="emc-add" data-v="' + v.id + '">Agregar</button></div>';
        }).join('');
        box.hidden = false;
      });
  }

  function syncCount(c) {
    document.querySelectorAll('[class*="header-cart-count"], [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    document.querySelectorAll('a[href="/cart"]').forEach(function (a) {
      var t = a.innerHTML; if (/\(\d+\)/.test(t)) a.innerHTML = t.replace(/\(\d+\)/, '(' + c.item_count + ')');
    });
  }

  function refresh(added) {
    getJSON('/cart.js').then(function (c) {
      var t = added && c.items && c.items[0] ? 'Agregado: ' + c.items[0].product_title : null;
      render(c, added ? t : null);
      syncCount(c);
    }).catch(function () {});
  }

  /* el ícono del carrito abre el panel (en la página /cart se deja normal) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="/cart"], a[href$="/cart"]');
    if (!a || a.closest('.emc-sheet') || /^\/cart/.test(location.pathname) || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    getJSON('/cart.js').then(function (c) { render(c, null); open(null); }).catch(function () { location.href = '/cart'; });
  }, true);

  function isAdd(url, method) {
    return /\/cart\/add/.test(String(url || '')) && String(method || 'GET').toUpperCase() === 'POST';
  }
  var of = window.fetch;
  if (of) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var method = (init && init.method) || (input && input.method);
      var p = of.apply(this, arguments);
      if (isAdd(url, method)) p.then(function (res) { if (res && res.ok) setTimeout(function () { refresh(true); }, 150); }).catch(function () {});
      return p;
    };
  }
  var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__emc = isAdd(u, m); return oo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__emc) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) setTimeout(function () { refresh(true); }, 150); });
    return os.apply(this, arguments);
  };
})();
